/**
 * @author       [Tim Vermaelen]
 * @date         [2023]
 * @link         [http://www.adequatelygood.com/JavaScript-Module-Pattern-In-Depth.html]
 * @namespace    [Blastic.Cookiebox]
 * @requires     [jQuery, Blastic]
 * @revision     [0.2]
 */

// @param ($): window.jQuery
// @param (ns): window.Blastic
window.Blastic = (function ($, ns) {

    // 1. ECMA-262/5
    'use strict';

    // 2. CONFIGURATION
    const cfg = {
        cache: {
            container: '.cookiebox',
            accept: '#cookiebox-accept',
            preference: '#cookiebox-pref',
            options: {
                gdpr: '#check-gdpr'
            }
        },
        events: {
            click: 'click',
            dataLayer: {
                accept: 'cookie-consent-accept',
                refuse: 'cookie-consent-refuse'
            }
        },
        options: {
            consent: {
                name: 'BlasticCookieConsent'
            }
        }
    };

    // 3. FUNCTIONS OBJECT
    ns.Cookiebox = {
        revision: 0.2,

        init: function () {
            this.cacheItems();

            if (this.container) {
                this.activate();
            }
        },

        cacheItems: function () {
            const { cache } = Object.assign(cfg);

            this.container = document.querySelector(cache.container);
            this.accept = document.querySelector(cache.accept);
            this.preference = document.querySelector(cache.preference);
            this.options = {
                gdpr: document.querySelector(cache.options.gdpr)
            };
        },

        activate: function () {
            this.verifyPreference();
            this.bindEvents();
        },

        bindEvents: function () {
            const { events } = Object.assign(cfg);

            this.preference.addEventListener(events.click, this.handlePreference.bind(this));
            this.accept.addEventListener(events.click, this.handleAccept.bind(this));
        },

        verifyPreference: function () {
            const { options } = Object.assign(cfg);
            const cbStatus = window.localStorage.getItem(options.consent.name);

            if (cbStatus) {
                $(this.container).hide();
            }
        },

        handlePreference: function () {
            const { events, options } = Object.assign(cfg);
            const isGdprChecked = this.options.gdpr.checked;
            const dlEvent = { event: isGdprChecked ? events.dataLayer.accept : events.dataLayer.refuse }

            window.localStorage.setItem(options.consent.name, isGdprChecked);
            this.updateDataLayer(dlEvent);

            $(this.container).hide();
        },

        handleAccept: function () {
            const { events, options } = Object.assign(cfg);

            window.localStorage.setItem(options.consent.name, true);
            this.updateDataLayer(events.dataLayer.accept);

            $(this.container).hide();
        },

        updateDataLayer: function (event) {
            if (Array.isArray(window.dataLayer)) {
                window.dataLayer.push(event);
            }
        }
    }

    // 4. NAMESPACE
    return ns;

})(window.jQuery, window.Blastic || {});
